import { Dropdown, Menu, Modal, Input, notification } from 'antd';
import { useState, useRef } from 'react';
import { UserOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import XForm from 'components/XForm';
import { putPasswordApi } from 'api/admin';
const { confirm } = Modal;

const formTailLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 14 },
};

const UserInfoNode = props => {
    const { username, usertype } = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
    const { logoutSuccess } = props;
    const xFormRef = useRef();
    const history = useHistory();
    const [modalVisible, setmodalVisible] = useState(false);
    const [okBtnLoading, setokBtnLoading] = useState(false);

    const loginOut = () => {
        confirm({
            title: '确认注销？',
            icon: <QuestionCircleOutlined />,
            content: '注销当前登录并返回登录页。',
            onOk() {
                sessionStorage.clear();
                logoutSuccess && logoutSuccess();
                const loginUrl = usertype === 'admin' ? '/adminLogin' : '/login';
                history.push(loginUrl);
            },
        });
    };

    // 弹窗确认
    const handelOk = () => {
        xFormRef.current.form?.submit();
    };

    // 弹窗取消
    const handelCancel = () => {
        setmodalVisible(false);
        xFormRef.current.form?.setFieldsValue({
            password: '',
            repassword: '',
        });
    };

    // 修改密码
    const onFinish = values => {
        setokBtnLoading(true);
        const { password, repassword } = values;
        if (password !== repassword) {
            notification.error({
                message: `输入的密码不一致，请确认。`,
            });
            setokBtnLoading(false);
            return;
        }
        const params = { password: values.password ? values.password : '' };
        putPasswordApi(params).then(res => {
            if (res.success) {
                notification.success({
                    message: `密码修改成功。`,
                });
                handelCancel();
            }
            setokBtnLoading(false);
        });
    };

    const menu = (
        <Menu>
            {usertype === 'admin' ? (
                <Menu.Item onClick={() => setmodalVisible(true)} key="changePassword">
                    修改密码
                </Menu.Item>
            ) : null}
            <Menu.Item onClick={loginOut} key="exit">
                注销
            </Menu.Item>
        </Menu>
    );

    const formItems = [
        {
            formItemApis: {
                label: '新密码',
                name: 'password',
                rules: [
                    { required: true },
                    { pattern: /^\S{6,50}$/, message: '请输入6-50位新密码' },
                ],
            },
            item: <Input.Password placeholder={'请输入6-50位新密码'} />,
        },
        {
            formItemApis: {
                label: '确认密码',
                name: 'repassword',
                rules: [{ required: true }, { pattern: /^\S{6,50}$/, message: '请确认密码' }],
            },
            item: <Input.Password type="password" placeholder={'请确认密码'} />,
        },
    ];

    return (
        <>
            <Dropdown overlay={menu}>
                <div className="userInfoNode">
                    <UserOutlined style={{ fontSize: 25, verticalAlign: 'text-bottom' }} />
                    <span className="nameText">{username}</span>
                </div>
            </Dropdown>

            <Modal
                title={'修改密码'}
                centered
                visible={modalVisible}
                onOk={handelOk}
                okButtonProps={{ loading: okBtnLoading }}
                onCancel={handelCancel}>
                <XForm
                    formApis={{
                        ...formTailLayout,
                        name: 'changePassWord',
                        onFinish: onFinish,
                    }}
                    formItems={formItems}
                    ref={xFormRef}
                />
            </Modal>
        </>
    );
};
export default UserInfoNode;
